import React from 'react'
import styled from 'styled-components'

import realBg from '@/images/faq-header-bg.gif'

import Search from '../search'
import Toggle from '../toggle'

const Container = styled.div`
  margin-bottom: 100px;

  position: relative;

  width: 100%;
  height: 465px;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  color: white;
  background-color: rgba(0, 0, 0, 0.7);

  &::after {
    z-index: -1;
    content: '';
    position: absolute;

    top: 0;
    left: 0;
    bottom: 0;
    right: 0;

    background-image: url(${realBg});
    background-size: 100%;
    background-position-y: 50%;
  }
`

const SearchContainer = styled.div`
  margin-top: -20px;
  width: 900px;

  display: flex;
  flex-direction: column;
  align-items: center;

  text-align: center;
`

const Headline = styled.h2`
  margin-bottom: 15px;
`

const Supportline = styled.span`
  margin-top: 15px;
`

type Props = {
  searchQuery: string
  onSearchInput: (query: string) => void
  onSearch: () => void

  filtering: 'SDK' | 'API'
  onSortSelect: (value: 'SDK' | 'API') => void
}

const Header = ({ searchQuery, onSearchInput, onSearch, filtering, onSortSelect }: Props) => {
  return (
    <Container>
      <SearchContainer>
        <Headline>Frequently Asked Questions</Headline>
        <Search value={searchQuery} onInput={onSearchInput} onSubmit={onSearch} />
        <Supportline>
          Sort questions by SDK or API below. Can’t find what you’re looking for? For SDK related
          questions,
          <br />
          contact us at <a href="mailto:sdk@giphy.com">sdk@giphy.com</a>. For API related questions,
          contact us at <a href="mailto:api@giphy.com">api@giphy.com</a>.
        </Supportline>
      </SearchContainer>

      <Toggle value={filtering} onChange={onSortSelect} />
    </Container>
  )
}

export default Header
